import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './services/auth.service';
import { RoleService } from './services/role.service';

@Component({
  selector: 'app-role-landing',
  standalone: true,
  template: '',
})
export class RoleLandingComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private roleService: RoleService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const userInfo = this.authService.getCurrentUserInfo();
    this.router.navigateByUrl(this.roleService.getDefaultRoute(userInfo?.role), { replaceUrl: true });
  }
}
